import { render, staticRenderFns } from "./dc2.vue?vue&type=template&id=605d5452&scoped=true&"
import script from "./dc2.vue?vue&type=script&lang=js&"
export * from "./dc2.vue?vue&type=script&lang=js&"
import style0 from "./dc2.vue?vue&type=style&index=0&id=605d5452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d5452",
  null
  
)

export default component.exports